import {
  Button,
  ChakraSelect,
  FormControl,
  FormLabel,
  HStack,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TOption = {
  value: boolean;
  label: string;
};

type TInputs = {
  isActive: TOption | undefined;
};

const activationOptions = [
  {
    value: true,
    label: 'Active',
  },
  {
    value: false,
    label: 'Inactive',
  },
];

const defaultValues: TInputs = {
  isActive: undefined,
};

export const ActivationFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (typeof params.isActive === 'boolean') setIsActive.on();
    else setIsActive.off();
  }, [params.isActive]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values
  const updateValues = () => {
    setValue(
      'isActive',
      activationOptions.find((o) => {
        if (typeof params?.isActive === 'boolean') {
          return o.value === params?.isActive;
        }

        return undefined;
      })
    );
  };

  useEffect(() => {
    updateValues();
  }, [params.isActive]);

  const onSubmit = (data: TInputs) => {
    params.isActive = data.isActive?.value as boolean;

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='isActive'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Activation</FormLabel>
                <ChakraSelect
                  id='isActive'
                  options={activationOptions}
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  value={value}
                />
              </FormControl>
            )}
          />

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
